<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <span class="ml-2">
          <router-link to="/areas">Районы</router-link>
          <span> / Название района</span>
        </span>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-tabs>
            <v-tab>Блоки дома</v-tab>
            <v-tab>Территории</v-tab>
            <v-tab>Сервисные ключи</v-tab>
            <v-tab>О районе</v-tab>
            <v-tab>Новости и акции района</v-tab>
            <v-tab-item class="tab-item  pb-1">
              <v-card class="ma-5">
                <v-row class="px-5">
                  <v-card-title>
                    Блоки
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      color="#1E6CEB"
                      dark
                      class="px-5"
                      absolute
                      right
                    >
                      Добавить блок
                    </v-btn>
                  </v-card-actions>
                </v-row>
                <v-data-table
                  class="table"
                  hide-default-footer
                  hide-default-header
                >
                  <template v-slot:header>
                    <thead>
                      <tr>
                        <th>id</th>
                        <th>Наименование</th>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:body>
                    <tbody>
                      <tr v-for="(block, index) in blocks" :key="index" >
                        <td>{{ block.id }}</td>
                        <td>{{ block.name }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-card>
              <v-card class="ma-5">
                <v-row class="px-5">
                  <v-card-title>
                    Дома
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      color="#1E6CEB"
                      dark
                      class="px-5"
                      absolute
                      right
                    >
                      Добавить дом
                    </v-btn>
                  </v-card-actions>
                </v-row>
                <v-data-table
                  class="table"
                  hide-default-footer
                  hide-default-header
                >
                  <template v-slot:header>
                    <thead>
                      <tr>
                        <th>id</th>
                        <th>Блок</th>
                        <th>Адрес</th>
                        <th>Кол-во квартир</th>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:body>
                    <tbody>
                      <tr v-for="(house, index) in houses" :key="index" >
                        <td>{{ house.id }}</td>
                        <td>{{ house.block }}</td>
                        <td>{{ house.address }}</td>
                        <td>
                          <v-row align="center">
                            <v-col cols="10">
                              <span>{{ house.countApartment }}</span>
                            </v-col>
                            <v-col cols="2">
                              <v-row>
                                <v-btn
                                  icon
                                  text
                                  small
                                  class="btn__icon pa-0"
                                  width="18"
                                  height="18"
                                >
                                  <span class="icon-eye"></span>
                                </v-btn>
                                <v-btn
                                  icon
                                  text
                                  small
                                  class="btn__icon pa-0"
                                  width="18"
                                  height="18"
                                >
                                  <span class="icon-edit"></span>
                                </v-btn>
                              </v-row>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <v-tab-item class="tab-item">
              <v-card class="pa-5">
                block2
              </v-card>
            </v-tab-item>
            <v-tab-item class="tab-item">
              <v-card class="pa-5">
                block3
              </v-card>
            </v-tab-item>
            <v-tab-item class="tab-item pb-1">
              <v-card class="ma-5 px-5 pb-5">
                <v-row>
                  <v-card-title>
                    Информация о районе
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      color="#1E6CEB"
                      dark
                      class="px-5"
                      absolute
                      right
                    >
                      Редактировать
                    </v-btn>
                  </v-card-actions>
                </v-row>
                <v-card-text class="py-0 px-1">
                  <p class="mb-1">Домов: {{ info.countHouse }}</p>
                  <p class="mb-1">Квартир: {{ info.countApartment }}</p>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item class="tab-item">
              <v-card
                class="pa-5"
                flat
              >
                <span class="title font-weight-regular"
                  >Новости и акции района</span
                >
              </v-card>
              <v-card
                v-for="(item, index) in news"
                :key="index"
                class="ma-5 pa-5"
              >
                <v-card-title class="pt-0">
                  {{ item.title }}
                </v-card-title>
                <v-row>
                  <v-col
                    cols="6"
                    class="py-0"
                  >
                    <v-card-text class="py-0">
                      {{ item.description }}
                    </v-card-text>
                  </v-col>
                  <v-col
                    cols="6"
                    class="py-0"
                  >
                    <v-card-actions class="py-0">
                      <v-btn
                        color="#1E6CEB"
                        dark
                        absolute
                        bottom
                        right
                        class="px-5"
                      >
                        Подробнее
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </v-card>
              <v-btn
                color="#1E6CEB"
                dark
                class="ma-5 px-5"
              >
                Новая новость
              </v-btn>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AreaDescription',
  data () {
    return {
      news: [
        {
          title: 'ЖК Аква',
          description: 'Тело сжатое с боков, довольно высокое, покрыто плотной ктеноидной чешуей, которая заходит даже на верхнюю часть жаберной крышки. У крупных рыб спина горбатая. Голова большая. На жаберной крышке один плоский шип, а предкрышка сзади зазубрена. Уколы шипами и колючими лучами плавников окуня болезненны. На челюстях и небных костях многорядные щетинковидные зубы. Окраска яркая. Окуни, обитающие в прозрачной воде, более светлые, а в лесных озерах с темной водой - темные, с ярко-желтым брюхом, в озерах с очень кислой реакцией воды - беловато-желтые. Тело зеленовато-желтое, на боках 5-9 поперечных широких черных полос. Спина темно-зеленая. Глаза оранжевые. Хвостовой, анальный, брюшные плавники красноватые, грудные плавники желто-красные. Первый спинной плавник серый, на его конце черное пятно, второй спинной - зеленовато-желтый. Первый и второй спинные плавники слегка раздвинуты, первый выше второго.',
        },
        {
          title: 'ЖК Казань2',
          description: 'Тело сжатое с боков, довольно высокое, покрыто плотной ктеноидной чешуей, которая заходит даже на верхнюю часть жаберной крышки. У крупных рыб спина горбатая. Голова большая. На жаберной крышке один плоский шип, а предкрышка сзади зазубрена. Уколы шипами и колючими лучами плавников окуня болезненны. На челюстях и небных костях многорядные щетинковидные зубы. Окраска яркая. Окуни, обитающие в прозрачной воде, более светлые, а в лесных озерах с темной водой - темные, с ярко-желтым брюхом, в озерах с очень кислой реакцией воды - беловато-желтые. Тело зеленовато-желтое, на боках 5-9 поперечных широких черных полос. Спина темно-зеленая. Глаза оранжевые. Хвостовой, анальный, брюшные плавники красноватые, грудные плавники желто-красные. Первый спинной плавник серый, на его конце черное пятно, второй спинной - зеленовато-желтый. Первый и второй спинные плавники слегка раздвинуты, первый выше второго.',
        },
        {
          title: 'ЖК Казань3',
          description: 'Тело сжатое с боков, довольно высокое, покрыто плотной ктеноидной чешуей, которая заходит даже на верхнюю часть жаберной крышки. У крупных рыб спина горбатая. Голова большая. На жаберной крышке один плоский шип, а предкрышка сзади зазубрена. Уколы шипами и колючими лучами плавников окуня болезненны. На челюстях и небных костях многорядные щетинковидные зубы. Окраска яркая. Окуни, обитающие в прозрачной воде, более светлые, а в лесных озерах с темной водой - темные, с ярко-желтым брюхом, в озерах с очень кислой реакцией воды - беловато-желтые. Тело зеленовато-желтое, на боках 5-9 поперечных широких черных полос. Спина темно-зеленая. Глаза оранжевые. Хвостовой, анальный, брюшные плавники красноватые, грудные плавники желто-красные. Первый спинной плавник серый, на его конце черное пятно, второй спинной - зеленовато-желтый. Первый и второй спинные плавники слегка раздвинуты, первый выше второго.',
        },
        {
          title: 'ЖК Казань4',
          description: 'Тело сжатое с боков, довольно высокое, покрыто плотной ктеноидной чешуей, которая заходит даже на верхнюю часть жаберной крышки. У крупных рыб спина горбатая. Голова большая. На жаберной крышке один плоский шип, а предкрышка сзади зазубрена. Уколы шипами и колючими лучами плавников окуня болезненны. На челюстях и небных костях многорядные щетинковидные зубы. Окраска яркая. Окуни, обитающие в прозрачной воде, более светлые, а в лесных озерах с темной водой - темные, с ярко-желтым брюхом, в озерах с очень кислой реакцией воды - беловато-желтые. Тело зеленовато-желтое, на боках 5-9 поперечных широких черных полос. Спина темно-зеленая. Глаза оранжевые. Хвостовой, анальный, брюшные плавники красноватые, грудные плавники желто-красные. Первый спинной плавник серый, на его конце черное пятно, второй спинной - зеленовато-желтый. Первый и второй спинные плавники слегка раздвинуты, первый выше второго.',
        },
        {
          title: 'ЖК Казань5',
          description: 'Тело сжатое с боков, довольно высокое, покрыто плотной ктеноидной чешуей, которая заходит даже на верхнюю часть жаберной крышки. У крупных рыб спина горбатая. Голова большая. На жаберной крышке один плоский шип, а предкрышка сзади зазубрена. Уколы шипами и колючими лучами плавников окуня болезненны. На челюстях и небных костях многорядные щетинковидные зубы. Окраска яркая. Окуни, обитающие в прозрачной воде, более светлые, а в лесных озерах с темной водой - темные, с ярко-желтым брюхом, в озерах с очень кислой реакцией воды - беловато-желтые. Тело зеленовато-желтое, на боках 5-9 поперечных широких черных полос. Спина темно-зеленая. Глаза оранжевые. Хвостовой, анальный, брюшные плавники красноватые, грудные плавники желто-красные. Первый спинной плавник серый, на его конце черное пятно, второй спинной - зеленовато-желтый. Первый и второй спинные плавники слегка раздвинуты, первый выше второго.',
        },
      ],
      info: {
        countHouse: 10,
        countApartment: 25,
      },
      blocks: [
        {
          id: 1,
          name: 'Первый',
        },
        {
          id: 2,
          name: 'Второй',
        },
        {
          id: 3,
          name: 'Третий',
        },
        {
          id: 4,
          name: 'Четвёртый',
        },
      ],
      houses: [
        {
          id: 1,
          block: 'Первый',
          address: 'ул.Гончарова 23',
          countApartment: 10,
        },
        {
          id: 2,
          block: 'Первый',
          address: 'ул.Гончарова 23',
          countApartment: 5,
        },
        {
          id: 3,
          block: 'Первый',
          address: 'ул.Гончарова 23',
          countApartment: 7,
        },
        {
          id: 4,
          block: 'Второй',
          address: 'ул.Гончарова 23',
          countApartment: 93,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.v-btn{
  text-transform: none;
}
.v-tab{
  text-transform: none;
}
</style>
